<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="qt-stage">
        <span class="qt-mark" aria-hidden="true">&ldquo;</span>
        <div class="qt-lines">
          <span class="qt-bar qt-bar--lg"></span>
          <span class="qt-bar qt-bar--md"></span>
        </div>
        <div class="qt-attr">
          <span class="qt-avatar"></span>
          <span class="qt-bar qt-bar--name"></span>
        </div>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewQuote',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.qt-stage {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
  min-height: 150px;
  padding: 0 20px;
}
.qt-mark {
  font-family: Georgia, serif;
  font-size: 56px;
  line-height: 0.5;
  color: var(--accent);
  margin-top: 20px;
}
.qt-lines {
  display: flex;
  flex-direction: column;
  gap: 7px;
  align-items: center;
  width: 100%;
}
.qt-bar {
  display: block;
  height: 9px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.22);
}
.qt-bar--lg { width: 80%; }
.qt-bar--md { width: 60%; }
.qt-bar--name {
  height: 7px;
  width: 70px;
  background: rgba(15, 15, 20, 0.5);
}
.qt-attr {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}
.qt-avatar {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--accent) 40%, rgba(15, 15, 20, 0.15));
}
</style>
